/**
 * Language Selection Component
 */
import React from 'react';
import { translations } from '../translations';

const LanguageSelector = ({ onSelect, currentLanguage, isLoading }) => {
  const languages = [
    { code: 'en', name: 'English', native: 'English' },
    { code: 'fa', name: 'Persian', native: 'فارسی' },
    { code: 'ps', name: 'Pashto', native: 'پښتو' },
    { code: 'tr', name: 'Turkish', native: 'Türkçe' },
    { code: 'ar', name: 'Arabic', native: 'العربية' }
  ];

  const t = translations[currentLanguage] || translations.en;

  return (
    <div className="afgcoin-chatbot-language-selector">
      <p className="afgcoin-chatbot-prompt">{t.languageSelection.prompt}</p>
      <div className="afgcoin-chatbot-language-buttons">
        {languages.map((lang) => (
          <button
            key={lang.code}
            className={`afgcoin-chatbot-language-button ${
              currentLanguage === lang.code ? 'afgcoin-chatbot-language-button-active' : ''
            }`}
            onClick={() => onSelect(lang.code)}
            disabled={isLoading}
          >
            <span className="afgcoin-chatbot-language-native">{lang.native}</span>
            <span className="afgcoin-chatbot-language-name">{lang.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;

